module.exports = __webpack_public_path__ + "static/digipay-caltex-banner-9533826b8d4c9eb5616032570a82faa4.jpg";